<div
  class="drop-container size-sm mb-2"
  [ngClass]="{ 'is-drop-over': dragOver, 'is-uploading': state === UploaderState.uploading }">
  <div
    ngFileDrop
    [options]="options"
    (uploadOutput)="onUploadOutput($event)"
    [uploadInput]="uploadInput">
    <label
      for="fileInput"
      class="drop-container__input-field position-relative">
      @if (state === UploaderState.selectFile) {
        <div class="container-text select-file">
          <div class="drop-container__title">{{ title }}</div>
          <p class="drop-container__text">
            {{ text }}
          </p>
          @if (textExtra) {
            <p class="drop-container__text">
              {{ textExtra }}
            </p>
          }
        </div>

        <div class="text-center">
          <div class="btn btn-light-on-white">Choose a file</div>
        </div>
      }

      <input
        ngFileSelect
        #fileInput
        id="fileInput"
        type="file"
        multiple
        class="drop-container__input-field"
        [options]="options"
        (uploadOutput)="onUploadOutput($event)"
        [uploadInput]="uploadInput"
        accept="application/pdf,image/*" />

      @if (state === UploaderState.uploading) {
        <div class="upload-progress">
          <div class="mb-3">
            <strong>Uploading receipt...</strong>
          </div>
          <ngb-progressbar
            type="primary"
            [value]="uploadProgress"
            [striped]="true"
            [animated]="true">
            {{ uploadProgress }}%
          </ngb-progressbar>
          @if (currentFile) {
            <div class="mt-2 text-muted small">
              {{ currentFile.name }}
            </div>
          }
        </div>
      }
    </label>
  </div>
  @if (errorMessage) {
    <div class="invalid-feedback d-block">
      @if (failureGroups.length > 1) {
        Receipts could not be uploaded:<br />
        @for (group of failureGroups; track group.error) {
          <div>
            @if (group.fileNames.length > 1) {
              {{ group.error }}
            } @else {
              File "{{ group.fileNames[0] }}" has an error: {{ group.error }}
            }
          </div>
        }
      } @else if (failureGroups.length === 1) {
        {{ failureGroups[0].error }}
      } @else {
        {{ errorMessage }}
      }
    </div>
  }
</div>
